import { gsap } from 'gsap'
import { colourArray, transBlack } from '../constants'

export default class ConnectionsBackground {
    
    constructor() {
        const canvas = document.createElement('canvas');
        canvas.className = 'fixed top-0 bottom-0 left-0 right-0 backgrounds';
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        this.ctx = canvas.getContext('2d');
        document.body.appendChild(canvas);

        this.showBg = true;
        this.animate = this.animate.bind(this);
        
        this.dots = [];
        this.globalOpacity = 0.1;

        window.addEventListener('load', () => {
            this.createConnection();
            this.animate();
        });

        window.addEventListener('scroll', this.scrollHandler.bind(this));
    }

    scrollHandler() {
        this.globalY = -window.pageYOffset / 4;
    }

    createConnection() {
        const w = window.innerWidth;
        const h = window.innerHeight;
        const dotRadius = Math.min(w, h) * 0.05;

        // Order green / yellow is random
        const randIndex = Math.floor(Math.random() * colourArray.length);
        const randColour = colourArray[randIndex];
        const nextColourIndex =  (randIndex + 1 + colourArray.length) % colourArray.length;
        const nextColour = colourArray[nextColourIndex];

        // We will give 
        const baseRadius = Math.min(window.innerWidth, window.innerHeight) * 0.1;
        const targetRadius = baseRadius + (baseRadius * Math.random() * 0.5);
        const randomSizes = [targetRadius, targetRadius * 1.5];
        const randomSizeIndex = Math.floor(Math.random() * randomSizes.length);
        const otherSizeIndex = 1 - randomSizeIndex;

        // add two new dots and make them collide to form new colours
        const newGroup = [
            {
                multiplier: 0.25 + Math.random(),
                x: Math.random() * w/4,
                y: -dotRadius * 2,
                radius: dotRadius,
                targetRadius: randomSizes[randomSizeIndex],
                rgba: { ...transBlack },
                target_rgba: { ...randColour },
            },
            {
                multiplier: 0.25 + Math.random(),
                x: Math.random() * w/4,
                y: h + dotRadius * 2,
                radius: dotRadius,
                rgba: { ...transBlack },
                target_rgba: { ...nextColour },
            },
            {
                multiplier: 0.25 + Math.random(),
                x: w - Math.random() * w/4,
                y: -dotRadius * 2,
                radius: dotRadius,
                targetRadius: randomSizes[otherSizeIndex],
                rgba: { ...transBlack },
                target_rgba: { ...nextColour },
            },
            {
                multiplier: 0.25 + Math.random(),
                x: w - Math.random() * w/4,
                y: h + dotRadius * 2,
                radius: dotRadius,
                rgba: { ...transBlack },
                target_rgba: { ...randColour },
            },
        ]

        this.dots = this.dots.concat(newGroup);

        // Do the crash
        this.index = 0;
        this.globalY = 0;
        this.runSequence();
    }

    runSequence() {
        const duration = 3;
        
        let targetX = document.querySelector('.page-content').getBoundingClientRect().x;
        let randomY = window.innerHeight * 1/3 + Math.random() * window.innerHeight / 6;

        gsap.to(this.dots[this.index], {
            x: targetX,
            y: randomY,
            duration,
            ease: 'power4.in',
            onComplete: () => this.explode(this.index)
        });

        gsap.to(this.dots[this.index + 1], {
            x: targetX,
            y: randomY,
            duration,
            ease: 'power3.in'
        });

        targetX = document.querySelector('.page-content').getBoundingClientRect().right;
        randomY = window.innerHeight * 2/3 + Math.random() * window.innerHeight / 3;

        gsap.to(this.dots[this.index + 2], {
            x: targetX,
            y: randomY,
            duration,
            ease: 'power4.in',
            delay: 0.5,
            onComplete: () => this.explode(this.index + 2),
        });

        gsap.to(this.dots[this.index + 3], {
            x: targetX,
            y: randomY,
            duration,
            delay: 0.5,
            ease: 'power3.in'
        });
    }

    explode(index) {
  
        let primaryDot = this.dots[index];
        let { r, g, b } = primaryDot.target_rgba;
        const radius = primaryDot.targetRadius;

        gsap.to(primaryDot, { radius, duration: 1, ease: 'power3.out' });
        gsap.to(primaryDot.rgba, { r, g, b, a: 0.5, duration: 1 });

        // And kill the other one
        let secondaryDot = this.dots[index + 1];
        secondaryDot.rgba.a = 0;

        setTimeout(() => this.globalOpacity = 0.2, 1000);
    }

    animate() {
        if (this.showBg) {
            this.ctx.rect(0, 0, window.innerWidth, window.innerHeight);
            this.ctx.fillStyle = `rgba(255, 255, 255, ${this.globalOpacity})`;
            this.ctx.fill();
        } else {
            this.ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        }

        for (let i = 0; i < this.dots.length; i++) {
            this.render(this.dots[i]);
        }

        this.raf = requestAnimationFrame(this.animate);
    }

    render({ x, y, radius, multiplier, rgba }) {
        this.ctx.beginPath();
        const { r, g, b, a } = rgba;
        this.ctx.fillStyle = `rgba(${r}, ${g}, ${b}, ${a})`;
        this.ctx.arc(x, y + this.globalY * multiplier, radius, 0, Math.PI * 2);
        this.ctx.fill();
        this.ctx.closePath();
    }
}